import { render, staticRenderFns } from "./rates-of-deduction.vue?vue&type=template&id=87daa7f6&"
import script from "./rates-of-deduction.vue?vue&type=script&lang=js&"
export * from "./rates-of-deduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports